import React, { Component } from 'react'
import LoadingWindow from '../../../components/LoadingWindow';
import "../../../css/general-style.css"
import '../../../css/dashboard.css'
import { getInformationWithData } from '../../../services/CABE';
import ExcelDocument from '../../../components/ExcelDocument';
import { getDataSet } from '../../../functions/generateDataSetExcel';
import { BsTruck, BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineCloudDownload, AiOutlineSearch } from "react-icons/ai";
import { Menu } from "../../../components/Menu/Menu";

export default class CurrentShippedItemsReport extends Component {

  state = {
    loading: false,
    progress: '',
    status: null, // 'success' | 'error' | null
    logs: [],
    data: [],
    filterData: [],
    search: '',
    errorMessage: 'Starting export process...',
    currentStep: 0,
    totalSteps: 0
  }

  // Add log message to state
  addLog = (message, type = 'info') => {
    const newLog = {
      message,
      type,
      timestamp: new Date().toLocaleTimeString()
    };

    this.setState(prevState => ({
      logs: [...prevState.logs, newLog]
    }));
  };

  // Make first request to get sales orders
  getSalesOrdersRequest = async () => {
    try {
      this.addLog('Making first request...');

      const payload = {
          SalespersonNo: "0000",
          idCompany: 3,
          idcompany: 3
      };

      const response = await getInformationWithData('/sales/get/header', payload);
      const result = response.data;

      if (response.status.code !== 1) {
        this.addLog(`Warning: Status is ${result.status}`, 'warning');
      }

      const dataObj = result || {};
      const data = typeof dataObj === 'object' && !Array.isArray(dataObj)
        ? dataObj.Tabla2 || []
        : Array.isArray(dataObj) ? dataObj : [];

      const salesOrders = data
      .map(item => item.SalesOrderNo)
      .filter(Boolean);

      this.addLog(`Found ${salesOrders.length} sales orders`, 'success');
      return salesOrders;

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      this.addLog(`Error in first request: ${errorMsg}`, 'error');
      throw error;
    }
  };

  // Make second request for specific sales order
  getSalesOrderItemsRequest = async (salesOrderNo) => {
    try {
      const detailPayload = {
        OrderNo: salesOrderNo,
        idcompany: 3,
        idCompany: 3
      };

      const response = await await getInformationWithData('/sales/get/detail', detailPayload);
      const result = response.data;

      const dataObj = result || {};
      const data = typeof dataObj === 'object' && !Array.isArray(dataObj)
        ? dataObj.Tabla2 || []
        : Array.isArray(dataObj) ? dataObj : [];

      const items = data.map(item => ({
        SalesOrder: salesOrderNo,
        itemCode: item.ItemCode || '',
        description: item.ItemCodeDesc || '',
        qty_ordered: item.QuantityOrdered || 0,
        qty_shipped: item.QuantityShipped || 0,
        invoiceNo: ''
      }));

      return items;

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      this.addLog(`Error for order ${salesOrderNo}: ${errorMsg}`, 'error');
      return [];
    }
  };

  // Make third request to get invoices
  getInvoicedSalesOrdersRequest = async () => {
    try {
      this.addLog('Fetching invoice data...');

      const invoicePayload = {
        CustomerNo: "*",
        SalespersonNo: "0000",
        idCompany: 3,
        idcompany: 3
      };

      const response = await getInformationWithData('/invoice/header', invoicePayload);
      const result = response.data;

      const dataObj = result || {};
      const data = typeof dataObj === 'object' && !Array.isArray(dataObj)
        ? dataObj.Tabla2 || []
        : Array.isArray(dataObj) ? dataObj : [];

      const invoiceMap = {};
      data.forEach(item => {
        const salesOrder = item.salesOrderNo || item.SalesOrderNo;
        const invoiceNo = item.invoiceNo || item.InvoiceNo;
        if (salesOrder) {
          invoiceMap[salesOrder] = invoiceNo || '';
        }
      });

      this.addLog(`Created invoice mapping for ${Object.keys(invoiceMap).length} orders`, 'success');
      return invoiceMap;

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;
      this.addLog(`Error fetching invoices: ${errorMsg}`, 'error');
      return {};
    }
  };

  // Add invoice numbers to items
  addInvoiceNumbers = (allItems, invoiceMap) => {
    return allItems.map(item => ({
      ...item,
      invoiceNo: invoiceMap[item.SalesOrder] || ''
    }));
  };

  Contains(parametro, busqueda) {
    if (parametro && busqueda) {
      return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }
    return false
  }

  handleSearch = (e) => {
    const search = e.target.value
    const filterData = search === '' ? this.state.data : this.state.data.filter(d =>
      this.Contains(d.SalesOrder, search) ||
      this.Contains(d.itemCode, search) ||
      this.Contains(d.description, search) ||
      this.Contains(d.invoiceNo, search)
    )
    this.setState({ search, filterData })
  }

  // Main export process - called when button is clicked
  handleExport = async () => {
    this.setState({
      loading: true,
      status: null,
      logs: [],
      progress: 'Starting...'
    });

    try {
      this.setState({
        progress: 'Fetching sales orders...',
        currentStep: 1,
        totalSteps: 5
      });
      const salesOrders = await this.getSalesOrdersRequest();

      if (salesOrders.length === 0) {
        throw new Error('No sales orders found');
      }

      this.setState({
        progress: `Processing ${salesOrders.length} orders...`,
        currentStep: 2
      });
      const allItems = [];

      for (let i = 0; i < salesOrders.length; i++) {
        const orderNo = salesOrders[i];
        this.addLog(`Processing order ${i + 1}/${salesOrders.length}: ${orderNo}`);
        this.setState({
          progress: `Processing order ${i + 1} of ${salesOrders.length}...`
        });

        const items = await this.getSalesOrderItemsRequest(orderNo);
        allItems.push(...items);
      }

      this.setState({
        progress: 'Fetching invoice data...',
        currentStep: 3
      });
      const invoiceMap = await this.getInvoicedSalesOrdersRequest();

      this.setState({
        progress: 'Matching invoices...',
        currentStep: 4
      });
      const finalData = this.addInvoiceNumbers(allItems, invoiceMap);

      this.setState({
        progress: 'Generating file...',
        currentStep: 5
      });

      this.setState({
        status: 'success',
        progress: `Successfully exported ${finalData.length} records!`,
        currentStep: 5,
        data: finalData,
        filterData: finalData,
        search: ''
      });

    } catch (error) {
      const errorMsg = (error.response && error.response.data && error.response.data.message) || error.message;

      this.setState({
        status: 'error',
        progress: 'Export failed',
        errorMessage: errorMsg
      });

    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { data, filterData, loading, progress, status, currentStep, totalSteps, errorMessage } = this.state;
    const progressPercentage = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;
    const hasData = data.length > 0;

    const rowClass = (item) => {
      if (Number(item.qty_shipped) === 0) return 'status-danger'
      if (Number(item.qty_shipped) < Number(item.qty_ordered)) return 'status-warning'
      return 'status-success'
    }

    return (
      <div className="dash-page" style={{ paddingTop: '70px' }}>
        {this.props.showMenu && <Menu Refresh={this.state.Refresh} Father={this} />}
        <LoadingWindow ref={this.ModalLoading} />

        {/* Hero */}
        <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
            <BsTruck style={{ color: 'white', fontSize: '1.75rem' }} />
          </div>
          <div style={{ flex: 1 }}>
            <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Current Shipped Items Report</h1>
            <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
              {hasData ? `${filterData.length} of ${data.length} records` : 'Export shipped items across all current sales orders'}
            </p>
          </div>
          <button onClick={this.handleExport} disabled={loading}
            style={{ background: loading ? 'rgba(255,255,255,0.08)' : 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: loading ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem', opacity: loading ? 0.7 : 1 }}>
            <AiOutlineCloudDownload /> {loading ? 'Processing...' : 'Export to CSV'}
          </button>
        </div>

        <div style={{ padding: '1.5rem 2rem' }}>

          {/* Progress Bar */}
          {loading && (
            <div className="card mb-4" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', padding: '1.25rem' }}>
              <div style={{ fontSize: '0.875rem', color: '#334155', fontWeight: 600, marginBottom: '0.625rem' }}>
                {progress}
              </div>
              <div style={{ width: '100%', height: '8px', background: '#E2E8F0', borderRadius: '4px', overflow: 'hidden', marginBottom: '0.4rem' }}>
                <div style={{ height: '100%', background: 'linear-gradient(135deg, #1e40af, #2563EB)', borderRadius: '4px', width: `${progressPercentage}%`, transition: 'width 0.3s ease' }} />
              </div>
              <div style={{ fontSize: '0.75rem', color: '#94A3B8', textAlign: 'right' }}>
                Step {currentStep} of {totalSteps}
              </div>
            </div>
          )}

          {/* Success Message */}
          {status === 'success' && !loading && (
            <div className="metric-card status-success mb-4" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ fontSize: '1.5rem', color: '#059669', fontWeight: 700 }}>✓</span>
              <div>
                <div style={{ fontWeight: 700, color: '#065F46', fontSize: '0.95rem' }}>Export Completed!</div>
                <div style={{ color: '#059669', fontSize: '0.8rem' }}>{progress}</div>
              </div>
            </div>
          )}

          {/* Error Message */}
          {status === 'error' && !loading && (
            <div className="metric-card status-danger mb-4" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <span style={{ fontSize: '1.5rem', color: '#DC2626', fontWeight: 700 }}>✕</span>
              <div>
                <div style={{ fontWeight: 700, color: '#991B1B', fontSize: '0.95rem' }}>Export Failed</div>
                <div style={{ color: '#DC2626', fontSize: '0.8rem' }}>{errorMessage}</div>
              </div>
            </div>
          )}

          {!hasData && !loading && status !== 'error' && (
            <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
              <BsTruck style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
              <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong>Export to CSV</strong> to fetch current shipped items.</p>
            </div>
          )}

          {/* Table */}
          {hasData && (
            <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
              <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.875rem 1.25rem', display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <div style={{ position: 'relative', flex: 1 }}>
                  <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)' }} />
                  <input
                    value={this.state.search}
                    onChange={this.handleSearch}
                    placeholder="Search by Sales Order, Item Code, Description, Invoice..."
                    type="text"
                    style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                  />
                </div>
                <ExcelDocument
                  data={getDataSet(filterData, ['Sales Order', 'Item Code', 'Description', 'Qty Ordered', 'Qty Shipped', 'Invoice'], ['SalesOrder', 'itemCode', 'description', 'qty_ordered', 'qty_shipped', 'invoiceNo'])}
                  sheetname={"Shipped Items"} />
              </div>
              <div className="tableFixHeadSmall">
                <table className='table table-clean mb-0'>
                  <thead>
                    <tr className="text-center">
                      <th>Sales Order {<span style={{ marginLeft: '3px', opacity: 0.5 }}><BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} /></span>}</th>
                      <th>Item Code</th>
                      <th className="text-start">Description</th>
                      <th>Qty Ordered</th>
                      <th>Qty Shipped</th>
                      <th>Invoice No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((element, e) => (
                      <tr key={e} className={rowClass(element)}>
                        <td className="text-center" style={{ fontWeight: 700, color: '#334155' }}>{element.SalesOrder}</td>
                        <td className="text-center">
                          <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 7px', fontSize: '0.72rem', fontWeight: 700 }}>{element.itemCode}</span>
                        </td>
                        <td className="text-start" style={{ fontSize: '0.875rem' }}>{element.description}</td>
                        <td className="text-center">{element.qty_ordered}</td>
                        <td className="text-center" style={{ fontWeight: 700, color: Number(element.qty_shipped) === 0 ? '#DC2626' : Number(element.qty_shipped) < Number(element.qty_ordered) ? '#D97706' : '#059669' }}>
                          {element.qty_shipped}
                        </td>
                        <td className="text-center" style={{ fontSize: '0.8rem', color: '#64748B' }}>{element.invoiceNo || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="tfoot">
                    <tr>
                      <td colSpan={6} style={{ color: '#94A3B8', fontSize: '0.78rem' }}>
                        {filterData.length} records · <span style={{ color: '#059669' }}>green</span> = fully shipped, <span style={{ color: '#D97706' }}>amber</span> = partial, <span style={{ color: '#DC2626' }}>red</span> = not shipped
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
